import angular from 'angular';

import component from './associated-entities-list.component';

const AssociatedEntitiesList = angular
    .module('control-room.commons.content.components.associated-entities-list', [])
    .component('crAssociatedEntitiesList', component);

export default AssociatedEntitiesList;
